import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { BASE_URL } from "./Constants.js";
import { useNavigate } from 'react-router-dom';
const OtpScreen1 = () => {
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const { id } = useParams(); // Get ID from URL
const navigate = useNavigate(); 
  const handleSubmit = async () => {
    if (!otp || otp.length !== 6 || isNaN(otp)) {
      setError('Please enter a valid 6-digit OTP');
      return;
    }

    try {
      setError('');
      const token = localStorage.getItem('authToken');

      const response = await fetch(`${BASE_URL}/verify_otp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ id, otp }),
      });

      const result = await response.json();

      if (result.status) {
        setSuccessMsg('OTP verified successfully!');
        navigate('/manage_candidates');
        // Redirect or take appropriate action
      } else {
        setError(result.message || 'Invalid OTP');
      }
    } catch (err) {
      console.error('API Error:', err);
      setError('Something went wrong while verifying OTP');
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
      <div className="card p-4" style={{ width: '350px', boxShadow: '0 0 10px rgba(0,0,0,0.1)' }}>
        <h4 className="text-center mb-4">Enter OTP</h4>
        <input
          type="text"
          className="form-control mb-3 text-center"
          maxLength="6"
          placeholder="6-digit OTP"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
        />
        {error && <p className="text-danger small">{error}</p>}
        {successMsg && <p className="text-success small">{successMsg}</p>}
        <button className="btn btn-primary w-100" onClick={handleSubmit}>
          Submit
        </button>
      </div>
    </div>
  );
};

export default OtpScreen1;
